import { MTextField, ResponsiveFormContainer } from "@app/components";
import { MODES_OPTIONS } from "@app/types/generics.types";
import { Divider, Grid, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useFormContext } from "react-hook-form";

interface ATPPFormFormProps {
  mode: MODES_OPTIONS;
}
const ATPPForm = ({ mode }: ATPPFormFormProps) => {
  const { watch, setValue } = useFormContext();
  const isView = mode === MODES_OPTIONS.VIEW;

  const incVolSampleK2L = watch("inc_vol_sample_k2_l");

  useEffect(() => {
    if (!incVolSampleK2L || isNaN(incVolSampleK2L)) {
      setValue("inc_vol_sample_k2_2_m3", "");
      setValue("inc_vol_sample_k1_u2_m3_2", "");
      return;
    }

    const incVolSampleK22M3 = parseFloat(incVolSampleK2L) * 1e-3;
    setValue("inc_vol_sample_k2_2_m3", incVolSampleK22M3.toFixed(6));

    const incVolSampleK1U2M32 = Math.pow(incVolSampleK22M3 / 2, 2);
    setValue("inc_vol_sample_k1_u2_m3_2", incVolSampleK1U2M32.toFixed(6));
  }, [incVolSampleK2L, setValue]);

  return (
    <>
      <Divider />
      <Grid item xs={12} my={3}>
        <Typography variant="tagText">
          {"Partículas de polvo. Unidades de volumen. Resultado en Bq/m3"}
        </Typography>
      </Grid>
      <ResponsiveFormContainer columns={2}>
        <MTextField
          name="inc_vol_sample_k2_l"
          label="Incert. del volumen muestra para k=2 (l)"
          type="number"
          fullWidth
          validation={{ required: "El valor es requerido" }}
          disabled={isView}
        />
        <MTextField
          name="inc_vol_sample_k2_2_m3"
          label="k=2 (m³)"
          type="number"
          fullWidth
          disabled
        />
        <MTextField
          name="inc_vol_sample_k1_u2_m3_2"
          label="k=1 U2 (m³)²"
          type="number"
          fullWidth
          disabled
        />
      </ResponsiveFormContainer>
    </>
  );
};

export default ATPPForm;
